import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { RTMP_LIST } from 'src/constants/queryKeys';

export const networkGetRtmpAppList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`RtmpApp/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchRtmpAPPList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [RTMP_LIST, pageIndex, payload],
    queryFn: () => networkGetRtmpAppList(payload, pageIndex, pageSize),
  });
}

export const networkCreateRtmpApp = async (data) => {
  const res = await axiosInstance.post('RtmpApp/Insert', data);
  return res;
};

export const networkUpdateRtmpApp = async (gameId, data) => {
  const res = await axiosInstance.post(`RtmpApp/Update/${gameId}`, data);
  return res;
};

export const networkRemoveRtmpApp = async (gameId) => {
  const res = await axiosInstance.post(`RtmpApp/Remove/${gameId}`);
  return res;
};

export const networkGetRtmpAppServerList = async (pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`RtmpAppServer/List/${pageIndex}/${pageSize}`);
  return res;
};

export function useFetchRtmpAPPServerList(pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['rtmp-app-server-list'],
    queryFn: () => networkGetRtmpAppServerList(pageIndex, pageSize),
  });
}
